import {RouterModule, Routes} from '@angular/router';

import {DashboardComponent} from './pages/dashboard/dashboard.page';
import {MasterDetailRootComponent} from './pages/root/master-detail-root.page';
import {NewsRoutes} from '../news/news-routing.module';
import {NgModule} from '@angular/core';
import {projectsRoutes} from '../projects/projects-routing.module';
import {TestPageComponent} from './pages/test-page/test-page.component';
import {nonProductionGuardFn} from '../../shared/guards/non-production.guard';
import {environment} from '../../../environments/environment';
import {permissionsGuardFn} from '../../shared/guards/permissions.guard';
import {SecFEPermissionPartnerAppEnum} from '../../shared/enums/sec-f-e-permission-partner-app-enum';
import {authenticationGuardFn} from '../../shared/guards/authentication-guard-fn';


const routes: Routes = [
    {
        path: '',
        component: MasterDetailRootComponent,
        canActivate: [authenticationGuardFn],
        children: [
            {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
            {path: 'dashboard', component: DashboardComponent},
            // {path: 'settings', component: SettingsComponent, data: {title: 'Accountverwaltung'}},
            {
                path: 'products',
                data: {title: 'Produktfinder'},
                loadChildren: () => import('../products/products.module').then(m => m.ProductsModule),
            },
            {
                path: 'solutions',
                data: {title: 'Lösungen'},
                loadChildren: () => import('../solutions/solutions.module').then(m => m.SolutionsModule),
            },
            {
                path: 'print-smart',
                canActivate: [permissionsGuardFn],
                canActivateChild: [permissionsGuardFn],
                data: {permissions: [SecFEPermissionPartnerAppEnum.__PAU_CONTRACTS]},
                loadChildren: () => import('../print-smart/print-smart.module').then(m => m.PrintSmartModule),
            },
            {
                path: 'projects',
                canActivate: [permissionsGuardFn],
                canActivateChild: [permissionsGuardFn],
                data: {permissions: [SecFEPermissionPartnerAppEnum.PAU_PROJECTS]},
                children: [...projectsRoutes]
            },
            {
                path: 'contact',
                loadChildren: () => import('brother-dealerapp-component-contacts-lib').then(m => m.BDCCContactsModule)
            },
            {
                path: 'news',
                children: [...NewsRoutes]
            },
            {
                path: 'sales-dashboard',
                loadChildren: () => import('../sales-dashboard/sales-dashboard.module').then(m => m.SalesDashboardModule)
            },
            {
                path: 'document-basket',
                loadChildren: () => import('../document-basket/document-basket.module').then(m => m.DocumentBasketModule)
            },

            {
                path: 'user-management',
                loadChildren: () => import('../user-management/user-management.module').then(m => m.UserManagementModule),
            },


            // {path: 'test', component: TestPageComponent, canActivate: [nonProductionGuardFn]}, // todo remove after angular upgrade will be fully finished and tested
            {path: '**', redirectTo: 'dashboard'}
        ]
    }
];

if (!(environment as any).enableOldFeatures) {
    const mainRoute = routes.find(route => route.path === '');
    mainRoute.children = mainRoute.children.filter(route => route.path !== 'products');
    mainRoute.children = mainRoute.children.filter(route => route.path !== 'solutions');
}

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MasterDetailRootRoutingModule {
}
